/* eslint-disable no-unused-vars */
import dayjs, { Dayjs } from 'dayjs'
import React, { MouseEvent, useState } from 'react'
import { IEvent } from '../../../types'
import CustomTooltip from '../common/CustomTooltip'
import styles from '../SAPPCalendar.module.css'
import MonthlyEvent from './MonthlyEvent'
import clsx from 'clsx'

interface IMonthlyCellProps {
  events: IEvent[]
  date: Dayjs
  currentDate: Dayjs
  onOpenDetail?: (date: Date, events: IEvent[]) => void
  onOpenCreate?: (date: Date) => void
  onEventDetail?: (event: IEvent) => void
  eventDetail?: {event: IEvent | null, date: Dayjs} | null
  setEventDetail?: (params: {event: IEvent | null, date: Dayjs}) => void
}

const MonthlyCell = ({
  currentDate,
  events,
  date,
  onOpenDetail,
  onOpenCreate,
  onEventDetail,
  eventDetail,
  setEventDetail
}: IMonthlyCellProps) => {
  const [isHovered, setIsHovered] = useState(false)
  const hasMore = events.length > 2
  const isSameMonth = currentDate.isSame(date, 'month')
  const isToday = dayjs().isSame(date, 'day')

  const handleOpenCreateModal = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target !== e.currentTarget) return
    onOpenCreate &&
      onOpenCreate(
        dayjs(date).hour(dayjs().hour()).minute(dayjs().minute()).toDate()
      )
  }

  const isOnDetail = eventDetail && eventDetail.date.isSame(date, 'day') && events.some(event => event.id === eventDetail.event?.id)

  return (
     <div
      className={clsx(
        styles['monthly-calendar__cell'],
        isToday ? styles['monthly-calendar__cell--active'] : styles['border-gray-4'],
        isSameMonth ? styles['bg-white'] : [styles['monthly-calendar__cell--not-current-month']],
        isOnDetail && styles['bg-active']
      )}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        height: isHovered ?'fit-content' : '',
        boxShadow: isHovered ? "0px 4px 16px 0px rgba(0, 0, 0, 0.08)" : '',
        transition: 'transform 0.2s ease-in-out',
        transform: isHovered ? 'scale(1.03)' : 'scale(1)',
        position: isHovered ?'absolute' : 'relative',
        zIndex: isHovered ? 1 : 0,
        width: isHovered ? '184px !important' : '100%',
        top: '0px',
        left: '0px',
        minHeight: "100%"
      }}
      onClick={handleOpenCreateModal}
    >
      <div className={styles["monthly-calendar__title-container"]}>
     <span
      className={clsx(
        styles["monthly-calendar__title-container-text"],
        isSameMonth ? styles['text-black'] : styles['text-secondary-text']
      )}
>
        {date.format('DD')}
        </span>
      </div>
    <ul onClick={() => onOpenDetail && onOpenDetail(date.toDate(), events)}>
  {(isHovered ? events : events.slice(0, 2)).map((event, index) => (
    <MonthlyEvent
      key={index}
      event={event}
      isSameMonth={isSameMonth}
      onEventDetail={onEventDetail}
      setEventDetail={setEventDetail}
      isOnDetail={eventDetail?.event?.id === event.id && eventDetail.date.isSame(date, 'day')}
      date = {date}
    />
  ))}
  {!isHovered && hasMore && (
    <CustomTooltip
      placement="bottom"
      title={
        <div className={styles['calendar-tooltip']}>
          {events.slice(2).map((event, index) => (
            <MonthlyEvent
              key={index}
              event={event}
              isSameMonth={isSameMonth}
              onEventDetail={onEventDetail}
              setEventDetail={setEventDetail}
              isOnDetail={eventDetail?.event?.id === event.id && eventDetail.date.isSame(date, 'day')}
              date = {date}
            />
          ))}
        </div>
      }
    >
      <div
        className={clsx( isSameMonth
            ? styles['text-success']
            : styles['text-secondary-text']
        )
         
        }
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        +{Math.max(events.length - 2, 0)} More
      </div>
    </CustomTooltip>
  )}
    </ul>
    </div>
  )
}

export default MonthlyCell
